import React from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { DefaultCulture } from '@/utils/localization';

const CurrencySymbol: React.FC<{ currency: string }> = ({ currency }) => {
    const currentCulture = useSelector((state: IState) => state.global.currentCulture);

    if (!currentCulture || !currency) {
        return null;
    }

    const format = new Intl.NumberFormat([currentCulture.locale, DefaultCulture.locale], {
        currency: currency,
        style: 'currency',
    });

    if (format.formatToParts) {
        return <>{format.formatToParts(1).find((x) => x.type === 'currency')?.value}</>;
    }

    return <>{currency}</>;
};

export default React.memo(CurrencySymbol);